import { Button, Input } from "antd";
import React, { useState } from "react";
import { styled } from "styled-components";
import { UserOutlined, KeyOutlined } from "@ant-design/icons";
import { Stack } from "@mui/material";
import { Lock } from "@mui/icons-material";
import { useAuth } from "../hooks/useAuth";
import { LogoColorSVG } from "../assets/svg/SvgIcons";

export default function Login() {
  const { login, loading } = useAuth();
  const [values, setValues] = useState({});

  const onChange = (prop) => (e) => {
    setValues({ ...values, [prop]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    login(values.email, values.password);
  };

  return (
    <Wrapper className="lightBg flexCenter">
      <LoginWrapper className="whiteBg radius8 flexColumn">
        <form onSubmit={onSubmit}>
          <div className="textCenter">
            <img src={LogoColorSVG} height={70} />
          </div>
          <h1 className="textCenter">
            <Lock /> Login
          </h1>
          <Stack spacing={3}>
            <Stack spacing={2}>
              <div>
                <p className="font14 light">Username</p>
                <Input
                  size="large"
                  required
                  style={{ fontSize: 14, height: 42 }}
                  placeholder="Username"
                  onChange={onChange("email")}
                  prefix={<UserOutlined />}
                />
              </div>
              <div>
                <p className="font14 light">Password</p>
                <Input.Password
                  placeholder="Password"
                  required
                  style={{ fontSize: 14, height: 42 }}
                  size="large"
                  onChange={onChange("password")}
                  prefix={<KeyOutlined />}
                />
              </div>
            </Stack>

            <Button
              size="large"
              type="primary"
              loading={loading}
              htmlType="submit"
            >
              Login
            </Button>
          </Stack>
        </form>
      </LoginWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
`;

const LoginWrapper = styled.div`
  line-height: 2;
  height: 100%;
  justify-content: center;
  width: 400px;
  padding: 40px;
  min-height: 50vh;
  @media (max-width: 860px) {
    width: 70%;
  }
`;
